import styles from './loadingIcon.module.css';
export default function LoadingIcon() {
    return(
        <div className={styles.loading_container}>
            <span className={styles.loader}></span>
        </div>
    )
}